import { gql } from '@apollo/client'

export default gql(`
    query{
        getContentBankSettings{
            id
            accessKey
            region
            s3BucketName
            secretAccessKey
        }
    }`
)
